import React from "react"
import styled, { css } from "styled-components"
import Parser from "html-react-parser"

import HeroImage from "../HeroImage"
import { Typography } from "@material-ui/core"

const Hero = props => {
  const { size, background_image, headline } = props
  return (
    <Container size={size}>
      {!!headline && (
        <Headline
          size={size}
          variant={size === "large" ? "h6" : "h1"}
          color="inherit"
        >
          {Parser(headline)}
        </Headline>
      )}
      {!!background_image && (
        <HeroImage
          bg={background_image.url}
          alt={background_image.alt}
          overlay
        />
      )}
    </Container>
  )
}

export default Hero

const Headline = styled(Typography)`
  @media (min-width: 800px) {
    transform: translateY(14px);
  }

  ${props =>
    props.size === "medium" || props.size === "small"
      ? css`
          transform: translateY(5px);
        `
      : css`
          transform: translateY(10px);
        `}
  position: relative;
  padding: 0 3vw;
  color: white;
  z-index: 1;
`

const Container = styled.div`
  @media (min-width: 1281px) {
    padding-top: 280px;
  }
  @media (max-width: 1280px) {
    ${props =>
      props.size === "medium" ? "padding-top: 30vw;" : "padding-top: 19.5vw;"}
  }
  position: relative;
  z-index: 0;
  color: white;
  overflow: hidden;
  min-height: 125px;
`
